<template>
  <a-modal class="xf-login-modal" width="590px" v-model:visible="visible" :maskClosable="false" :closable="false">
    <template #title>
      <div class="header-box">
        <span>登录/注册</span>
        <!-- @click="openPage('https://www.yuque.com/qiangzi-0veiu/ge9g4z/dfpcbn2irt604115?singleDoc#')"> -->
        <a-button
          type="primary"
          style="font-size: 15px"
          @click="openPage('https://www.yuque.com/qiangzi-0veiu/ge9g4z/cu1bt6etzw37apmz?singleDoc')"
        >
          使用教程
        </a-button>
      </div>
    </template>
    <div class="box">
      <div class="tip">
        <a-tag color="red" style="font-size: 15px; margin-bottom: 1em">
          如果之前没有注册过，点击【登录/注册】按钮后会展示支付宝二维码授权
        </a-tag>
      </div>
      <div class="item">
        <div class="label">支付宝小程序名称</div>
        <div class="input">
          <a-input
            v-model:value="params.nickName"
            ref="nickName"
            allowClear
            placeholder="请输入支付宝小程序名称 (商户名称, 注册时必填)"
          />
        </div>
      </div>
      <div class="item">
        <div class="label">
          <span>晓风分销账号</span>
          <a href="https://b.alipay.com/page/grow-biz/apps" target="_blank">获取小程序appid，立即前往>>></a>
        </div>
        <div class="input">
          <a-input
            v-model:value="params.userName"
            ref="userName"
            allowClear
            placeholder="请输入支付宝小程序appid (必填项)"
          />
        </div>
      </div>
      <div class="item">
        <div class="label">
          <span>晓风分销密码</span>
          <span class="tip">首次注册请牢记密码，也可以使用商户号当密码登录</span>
        </div>
        <div class="input">
          <a-input v-model:value="params.pwd" ref="pwd" allowClear placeholder="请输入晓风分销密码 (必填项)" />
        </div>
      </div>
    </div>
    <template #footer>
      <a-space>
        <a-button type="primary" :loading="loading" @click="login">登录/注册</a-button>
        <a-button type="primary" :loading="loading" danger @click="visible = false">关闭窗口</a-button>
      </a-space>
    </template>
  </a-modal>
</template>
<script>
import api from "./api";
import aliUtil from "@/utils/check_ali_auth";
export default {
  data() {
    return {
      visible: false,
      loading: false,
      params: {},
    };
  },
  methods: {
    show() {
      this.visible = true;
      this.params = {};
      this.loading = false;
    },
    checkParams() {
      if (!this.params.userName) {
        this.$refs.userName.focus();
        return "请先填写晓风分销账号 (支付宝小程序AppID)";
      }
      if (!this.params.pwd) {
        this.$refs.pwd.focus();
        return "请先填写晓风分销密码";
      }
    },
    async login() {
      const errMsg = this.checkParams();
      if (errMsg) return this.$message.warn(errMsg);
      this.loading = true;
      const { success, msg, result } = await api.Login(this.params);
      this.loading = false;
      // 登录成功
      if (success && result?.Token) {
        this.$message.success("登录成功");
        this.sendData(result);
        aliUtil.SyncCategory();
      }
      // 注册 (扫码授权)
      else if (!success && result?.QrCodeUrl) {
        this.$message.info(msg);
        this.sendData(result);
      }
      // 返回错误信息
      else if (msg) {
        // 注册时是必须填写的
        if (msg?.includes("需要填写商户名称")) this.$refs.nickName.focus();
        this.$message.warning(`登录失败，原因:【${msg}】`);
      }
    },
    sendData(result) {
      this.visible = false;
      result.userData = this.params;
      this.$emit("change", result);
    },
    openPage(url) {
      url && window.open(url);
    },
  },
};
</script>
<style lang="less">
@import "./index";
</style>
